import React from 'react';
import { TableCard, Box, Filter } from 'vindi-ds-components';
import EmptyCard from './emptyCard';

import useFilter from '../hooks/useFilter';
import useKindTagChip from '../hooks/useKindTagChip';

function TableCardCustomers({ status, setDescription }) {
  const { listing } = useFilter({ status });

  const descriptions = {
    active: 'Clientes com uma ou mais assinaturas ativas',
    inactive:
      'Clientes com assinaturas encerradas ou que nunca possuíram assinatura',
    delinquent: 'Clientes com cobranças vencidas',
    archived: '',
  };

  React.useEffect(() => {
    setDescription(descriptions[status]);
  }, [status]);

  const handleClick = (id) => {
    window.location.assign(`/admin/customers/${id}`);
  };

  if (listing?.query?.data?.customers.length === 0) {
    return <EmptyCard />;
  }

  return (
    <Filter.FilterProvider {...listing}>
      <Box display='flex' flexDirection='column' gridGap='16px'>
        {listing?.query?.data?.customers?.map((customer) => (
          <TableCard.Container key={customer.id} onClick={() => handleClick(customer.id)}>
            <TableCard.TextWithAction
              label='Nome'
              value={customer.name}
              key={customer.id}
            />
            <Box display='flex' gap='8px' alignItems='flex-end'>
              {customer.status.map((tag, index) => {
                const tagStatus = useKindTagChip(tag);
                return (
                  <Box display='flex' key={tag}>
                    <TableCard.TextWithTagChip
                      label={index === 0 ? 'Status' : ''}
                      value={tagStatus.label}
                      kind={tagStatus.kind}
                      key={`${customer.id}-${tag}`}
                    />
                  </Box>
                );
              })}
            </Box>
          </TableCard.Container>
        ))}
      </Box>
      <Filter.Pagination />
    </Filter.FilterProvider>
  );
}

export default TableCardCustomers;
